import { Component, Input } from '@angular/core';
import { PriceCalculatorProvider } from '../../providers/price-calculator/price-calculator';
import { PromoProvider } from '../../providers/promo/promo';
import { TranslateService } from '@ngx-translate/core';
import { Region, APP_CONFIG } from '../../environment';
@Component({
  selector: 'rmt-send-summary-small',
  templateUrl: 'rmt-send-summary-small.html'
})
export class RmtSendSummarySmallComponent {
  @Input() loading = false;
  @Input() disclosure = true;
  @Input() order = null;
  highlightFeeCss = '';
  highlightTimeout;
  isCreditCardAndUSA = false;

  detailsFee = ''
  totalReceivedWithDisclosure = ''
  creditCardFeesAlert = ''
  moneyTransferDetailsDisclosure = ''
  constructor(private translate: TranslateService, private promoProvider: PromoProvider) {
  }


  ngOnInit() {
    this.detailsFee = this.translate.instant('page.sendReceiptPage.detailsFee')
    this.totalReceivedWithDisclosure = this.translate.instant('page.sendSummaryPage.totalReceivedWithDisclosure')
    this.creditCardFeesAlert = this.translate.instant('page.paymentMethods.creditCardFees.alert')
    this.moneyTransferDetailsDisclosure = this.translate.instant('page.sendSummaryPage.moneyTransferDetailsDisclosure')
    if (this.disclosure && this.order && this.order.paymentMethod == 'CreditCard' && APP_CONFIG.region.region == Region.US) {
      this.isCreditCardAndUSA = true;
      this.modifyDisclaimerText();
    }
  }

  highlightFee() {
    if (this.highlightTimeout)
      window.clearTimeout(this.highlightTimeout);

    this.highlightFeeCss = '';
    window.requestAnimationFrame(() => {
      this.highlightFeeCss = 'highlight-row';
      this.highlightTimeout = window.setTimeout(() => {
        this.highlightFeeCss = '';
      }, 4000);
    });
  }

  getRate() {
    if (this.order)
      return PriceCalculatorProvider.updateRate(this.order.exchangeRate);    
    return '';
  }

  getPromoRate() {
    if (this.order)
      return PriceCalculatorProvider.updateRate(this.order.calculatedRatePromo);
    return '';
  }

  getFeeDiscount() {
    if (this.order && this.order.originalCustomerFee)
      return (this.order.originalCustomerFee - this.order.customerFee);
    return null;
  }

  getFee() {
    if (this.order.originalCustomerFee)
      return this.order.originalCustomerFee
    return this.order.customerFee;
  }

  hasFeeDiscount() {
    if (this.order && this.order.isPromoValid) {
      const feeDiscount = this.getFeeDiscount();
      let fee;
      if(this.order.originalCustomerFee > 0)
        fee = this.order.originalCustomerFee;
      else
        fee = this.order.customerFee;

      if (fee !== feeDiscount && feeDiscount > 0)
        return true;
      if (!this.order.customerFee && fee == feeDiscount)
        return true;
    }
    return false;
  }

  canShowReferralDiscount() {
    return this.promoProvider.canShowReferralDiscount(this.order);
  }

  modifyDisclaimerText() {
    this.detailsFee = this.detailsFee + "*";
    this.totalReceivedWithDisclosure = this.totalReceivedWithDisclosure + "*";
    this.creditCardFeesAlert = "*" + this.creditCardFeesAlert;
    this.moneyTransferDetailsDisclosure = "*" + this.moneyTransferDetailsDisclosure;
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-send-summary-small/rmt-send-summary-small.ts